import { CheckOutlined, PlusCircleOutlined, UploadOutlined } from "@ant-design/icons";
import { Button, Col, Flex, Form, Input, Row, Space, Table, Tooltip, Upload, UploadFile, UploadProps } from "antd";
import dayjs from "dayjs";
import React, { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../../../util/hooks";
import { currencyBRL, realParaNumber } from "../../../../util/dinheiroBRAuxiliar";
import "./style/index.scss";
import { PrestacaoContaModel } from "../../../../models/prestacaoConta/prestacaoContaModel";
import { cadastrarPrestacaoContaConsignatario } from "../../../../services/prestacaoContaService";
import { somaValores } from "../../../../util/anexoConsignatarioAuxiliar";
import { useLocation } from "react-router-dom";
import { toastWarning } from "../../../../util/toast";
import NumberInput from "../../../../components/inputs/numberInput";
import * as PhosphorIcon from "phosphor-react";
import { ButtonComponent } from "../../../../components/button/cadastrar";

dayjs.locale("pt-br");

interface Item {
  key: string;
  arquivo: UploadFile;
  valor: number | null;
  idTipoArquivoAnexo: number | null;
  nome: string | null;
  numeroNotaFiscal: string | null;
}

interface EditableCellProps extends React.HTMLAttributes<HTMLElement> {
  editing: boolean;
  dataIndex: string;
  title: any;
  inputType: "number" | "image";
  record: Item;
  index: number;
}

type UploadArquivosComponentConsigProps = {
  valor: number;
  entity: any;
  idTipoArquivoAnexo: number;
};

const UploadArquivosComponentConsig = ({ valor, entity, idTipoArquivoAnexo }: UploadArquivosComponentConsigProps) => {
  //estados globais
  const vendaConsignatarioState = useAppSelector((state) => state.vendaConsignatario);
  const persistedState = useAppSelector((state) => state.persisted);
  const prestacaoContaState = useAppSelector((state) => state.prestacaoConta);

  //hooks
  const dispatch = useAppDispatch();
  const { pathname } = useLocation();

  //estados locais
  const [formManual] = Form.useForm<Item>();
  const [count, setCount] = useState<number>(1);
  const [editingKey, setEditingKey] = useState<string>("");
  const [dataSource, setDataSource] = useState<Item[]>([]);

  const fetchData = () => {
    var initialData: Item[] = [];
    const listaAnexos: any[] = vendaConsignatarioState.listAnexo;
    const leng = vendaConsignatarioState.listAnexo.length;
    for (let i = 0; i < leng; i++) {
      initialData.push({
        key: i.toString(),
        arquivo: {
          uid: "-1",
          name: listaAnexos[i].nome,
          status: "done",
          url: listaAnexos[i].caminhoArquivo,
          type: listaAnexos[i].extensaoArquivo,
        },
        idTipoArquivoAnexo: listaAnexos[i].idTipoArquivoAnexo,
        valor: listaAnexos[i].valor,
        numeroNotaFiscal: listaAnexos[i].numeroNotaFiscal,
        nome: listaAnexos[i].nome,
      });
    }
    setCount(listaAnexos.length + 1);
    setDataSource(initialData);
  };

  useEffect(() => {
    fetchData();
    setEditingKey("");
  }, [vendaConsignatarioState.listAnexo, prestacaoContaState.listaAnexos]);

  const toBase64 = (img: any, callback: any) => {
    const reader = new FileReader();
    reader.addEventListener("load", () => callback(reader.result));
    reader.readAsDataURL(img);
  };

  const handleImageChange: UploadProps["onChange"] = ({ fileList: newFileList, file: newFile }) => {
    if (newFileList[0] !== undefined) {
      formManual.setFieldValue("arquivo", { url: newFileList[0].originFileObj, type: newFileList[0].type, name: newFileList[0].name });

      // toBase64(newFileList[0].originFileObj, (imageUrlResponse: any) => {
      //   formManual.setFieldValue("arquivo", { url: imageUrlResponse, type: newFileList[0].type, name: newFileList[0].name });
      // });
    } else {
      formManual.setFieldValue("arquivo", newFileList);
    }
  };

  const EditableCell: React.FC<React.PropsWithChildren<EditableCellProps>> = ({ editing, dataIndex, title, inputType, record, index, children, ...restProps }) => {
    const inputNode =
      inputType === "image" ? (
        <Upload
          defaultFileList={formManual.getFieldValue("arquivo") !== undefined ? [formManual.getFieldValue("arquivo")] : []}
          action={"dummyRequest"}
          onChange={handleImageChange}
          beforeUpload={(file) => {
            const isOk = file.type === "image/png" || file.type === "application/pdf" || file.type === "image/jpeg";
            if (!isOk) {
              toastWarning("Selecione um arquivo com extensão PDF, PNG ou JPG.");
            }

            return false;
          }}
        >
          {formManual.getFieldValue("arquivo") !== undefined && formManual.getFieldValue("arquivo").length !== 0 ? <></> : <Button icon={<UploadOutlined />}>anexar</Button>}
        </Upload>
      ) : inputType === "number" ? (
        <NumberInput tipo="c" precisao={2} />
      ) : (
        <Input type="text" style={{ textAlign: "right" }} />
      );

    return (
      <td {...restProps}>
        {editing ? (
          <Form.Item
            name={dataIndex}
            className="formPrestacao"
            style={{ margin: 0 }}
            rules={[
              {
                required: true,
                message: "Campo obrigatório",
              },
            ]}
          >
            {inputNode}
          </Form.Item>
        ) : (
          <div className="editable-cell-value-wrap valorAnexo" style={{ paddingRight: 24 }}>
            {children}
          </div>
        )}
      </td>
    );
  };

  const isEditing = (record: Item) => record.key === editingKey;

  const edit = async (record: Partial<Item> & { key: React.Key }) => {
    formManual.setFieldsValue({
      arquivo: record.arquivo,
      idTipoArquivoAnexo: record.idTipoArquivoAnexo,
      valor: record.valor,
      nome: record.nome,
      numeroNotaFiscal: record.numeroNotaFiscal,
    });
    setEditingKey(record.key);
  };

  const handleDelete = async (key: React.Key) => {
    setDataSource([...dataSource.filter((item: any) => item.key !== key)]);
  };

  const cancel = (key: React.Key) => {
    const search = dataSource.find((data: any) => data.key === key);
    if (search) {
      handleDelete(key);
    }
    setEditingKey("");
  };

  const handleAdd = () => {
    if (editingKey === "") {
      const newData: Item = {
        key: count.toString(),
        arquivo: {} as UploadFile,
        idTipoArquivoAnexo: idTipoArquivoAnexo,
        valor: null,
        nome: null,
        numeroNotaFiscal: null,
      };
      setDataSource([...dataSource, newData]);
      setEditingKey(count.toString());
      setCount(count + 1);
      formManual.resetFields();
      formManual.setFieldsValue({ valor: 0 });
    } else {
      toastWarning("Para adicionar uma novo item, salve primeiro o item que já está em edição.");
    }
  };

  const save = async (key: React.Key) => {
    try {
      const row = (await formManual.validateFields()) as Item;
      const newData = [...dataSource];
      const index = newData.findIndex((item) => key === item.key);
      if (index > -1) {
        const item = newData[index];
        newData.splice(index, 1, {
          ...item,
          ...row,
          valor: realParaNumber(formManual.getFieldValue("valor")),
          idTipoArquivoAnexo: idTipoArquivoAnexo,
        });
        setDataSource(newData);
        setEditingKey("");
      } else {
        newData.push(row);
        setDataSource(newData);
        setEditingKey("");
      }
    } catch (e) {}
  };

  const columns = [
    {
      dataIndex: "arquivo",
      editable: true,
      render: (arquivo: UploadFile) => <Upload style={{ width: 100 }} defaultFileList={[arquivo]} showUploadList={{ showRemoveIcon: false }}></Upload>,
    },
    {
      dataIndex: "valor",
      editable: true,
      align: "right" as "right",
      render: (_: any, record: any) => record.valor && currencyBRL(record.valor),
    },
    {
      dataIndex: "numeroNotaFiscal",
      editable: true,
      align: "right" as "right",
    },
    {
      align: "right" as "right",
      render: (_: any, record: Item) => {
        const editable = isEditing(record);
        return editable ? (
          <Flex justify="center" align="center" gap={4}>
            <Tooltip title="Salvar">
              <PhosphorIcon.CheckCircle style={{ cursor: "pointer" }} size={20} color="#334155" onClick={() => save(record.key)} />
            </Tooltip>
            <Tooltip title="Cancelar">
              <PhosphorIcon.XCircle style={{ cursor: "pointer" }} size={20} color="#334155" onClick={() => cancel(record.key)} />
            </Tooltip>
          </Flex>
        ) : (
          <Flex justify="center" gap={4}>
            <Tooltip title="Editar">
              <PhosphorIcon.Pencil style={{ cursor: "pointer" }} size={20} color="#334155" onClick={() => edit(record)} />
            </Tooltip>
            <Tooltip title="Remover">
              <PhosphorIcon.Trash style={{ cursor: "pointer" }} size={20} color="#334155" onClick={() => handleDelete(record.key)} />
            </Tooltip>
          </Flex>
        );
      },
    },
  ];

  const mergedColumns = columns.map((col) => {
    if (!col.editable) {
      return col;
    }

    return {
      ...col,
      onCell: (record: Item) => ({
        record,
        inputType: col.dataIndex === "arquivo" ? "image" : col.dataIndex === "valor" ? "number" : "text",
        dataIndex: col.dataIndex,
        title: col.dataIndex,
        editing: isEditing(record),
      }),
    };
  });

  const submit = async (value: any) => {
    var arquivoJson: any[] = [];
    dataSource.forEach((v: any, index: any) => {
      var detalhes = {
        caminhoArquivo: v.arquivo.url,
        extensaoArquivo: v.arquivo.type,
        idTipoArquivoAnexo: v.idTipoArquivoAnexo,
        nome: v.arquivo.name,
        valor: realParaNumber(v.valor),
        numeroNotaFiscal: v.numeroNotaFiscal,
      };
      arquivoJson.push(detalhes);
    });
    var arquivo: PrestacaoContaModel = {
      idVendaConsignatario: entity.id,
      idConsignatario: entity.idConsignatario,
      dataTransacao: null,
      idTipoArquivoAnexo: idTipoArquivoAnexo,
      prestacaoContaConsignatario: arquivoJson,
      idsConsignatario: null,
      idSorteio: null,
    };
    if (editingKey === "") {
      dispatch(
        cadastrarPrestacaoContaConsignatario({
          value: arquivo,
          busca: {} as any,
          buscaAnexoPrestacao: vendaConsignatarioState.entity.id,
          buscaAnexoVenda: {
            idTipoArquivo: idTipoArquivoAnexo,
            idVendaConsignatario: vendaConsignatarioState.entity.id,
          },
          buscaVenda:
            pathname === "/controleComprovanteConsignatario"
              ? vendaConsignatarioState.busca
              : {
                  idSorteio: vendaConsignatarioState.busca.idSorteio,
                  idEmpresa: vendaConsignatarioState.busca.idEmpresa,
                  idConsignatario: persistedState.user.idConsignatario,
                },
          origem: "prestacaoConta",
        })
      );
    } else {
      toastWarning("Para salvar seus itens, salve primeiro o item que está em edição.");
    }
  };

  return (
    <Flex vertical>
      <Form layout="vertical">
        <Flex justify="space-between" align="center" style={{ marginTop: -24 }}>
          <ButtonComponent onClick={handleAdd}>Adicionar</ButtonComponent>
          <ButtonComponent onClick={submit} icon={<CheckOutlined />}>
            SALVAR
          </ButtonComponent>
        </Flex>
      </Form>
      <Form form={formManual} component={false}>
        <Row gutter={12}>
          <Col span={24}>
            <Form.Item>
              <Table
                size="small"
                components={{
                  body: {
                    cell: EditableCell,
                  },
                }}
                rowClassName="editable-row"
                dataSource={dataSource}
                columns={mergedColumns}
                pagination={false}
                loading={vendaConsignatarioState.loading}
              />
            </Form.Item>
          </Col>
        </Row>
      </Form>
      <Row gutter={12} justify="end">
        <Col
          style={{
            color: "#334155",
            paddingRight: 0,
            fontWeight: 500,
          }}
        >
          <p>Valor total:</p>
        </Col>
        <Col style={{ fontWeight: 600, color: "#334155" }}>
          <p>{currencyBRL(somaValores(dataSource))}</p>
        </Col>
      </Row>
      {somaValores(dataSource) < valor ? (
        <Row gutter={12} justify="end">
          <Col
            style={{
              color: "#334155",
              paddingRight: 0,
              fontWeight: 500,
            }}
          >
            <p>Valor pendente:</p>
          </Col>
          <Col style={{ fontWeight: 600, color: "#334155" }}>
            <p>{currencyBRL(valor - somaValores(dataSource))}</p>
          </Col>
        </Row>
      ) : somaValores(dataSource) > valor ? (
        <Row gutter={12} justify="end">
          <Col
            style={{
              color: "#334155",
              paddingRight: 0,
              fontWeight: 500,
            }}
          >
            <p>Valor excedente:</p>
          </Col>
          <Col style={{ fontWeight: 600, color: "#334155" }}>
            <p>{currencyBRL(somaValores(dataSource) - valor)}</p>
          </Col>
        </Row>
      ) : (
        ""
      )}
    </Flex>
  );
};

export default UploadArquivosComponentConsig;
